/* eslint-disable no-case-declarations */
import { combineReducers } from 'redux';
import {
  FETCH_INSTANCE_REQUEST,
  FETCH_INSTANCE_SUCCESS,
  FETCH_INSTANCE_FAILURE,
} from '../../constants/ActionTypes';

const list = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_INSTANCE_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_INSTANCE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_INSTANCE_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

const instance = combineReducers({
  list,
});

export default instance;
